import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import { loadBlogList } from "@/lib/seo/blogList";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/en/blog/")({
  loader: () => loadBlogList("en"),
  head: () => buildRouteHead("/en/blog"),
  component: Blog,
});

